import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import "./HomeBanner.css";
import bgBannerImage from "../../../../Assets/Images/HomeBanner.png";
import { getData } from "../../../../Services/Api";
export default function HomeBanner() {
  const [headerContent, setHeaderContent] = useState();

  const getHeaderContent = async () => {
    const getDataResponse = await getData("get-header-content");
    setHeaderContent(getDataResponse?.data?.data[0] || []);
  };

  useEffect(() => {
    getHeaderContent();
  }, []);

  const renderDescription = (description) => {
    if (!description) return null;

    return description.split("\n").map((item, index) => (
      <div key={index} className="fs-6 py-2 d-flex">
        <div className="pe-2">&#10004;</div> {item.trim()}
      </div>
    ));
  };

  return (
    <div className="home-banner" id="homeBanner">
      <Container className="py-5 pb0">
        <div className="row py-5 pt0 pb0">
          <div className="col-lg-6">
            {/* <div className="banner-inner">
              <h1 className="heading-xl fw-bold py-3 ">
                Connect with Confidence <br /> Guard Your Privacy
              </h1>
              <p className="paragraph1 py-3 fs-5 fw-bold">#1 Trusted Leader in VPN</p>
              <div className="">
                <div className="fs-6 py-2 d-flex pt-0">
                  <div className="pe-2 ba">&#10004;</div> Double Encryption for
                  Enhanced Security
                </div>
                <div className="fs-6 py-2 d-flex">
                  <div className="pe-2">&#10004;</div> Smart Location Switching for
                  Optimal Performance
                </div>
                <div className="fs-6 py-2 d-flex">
                  <div className="pe-2">&#10004;</div> Adaptive Kill Switch for
                  Uninterrupted Privacy
                </div>
              </div>
            </div> */}
            <div className="banner-inner">
              <h1 className="heading-xl fw-bold py-3 ">
                {headerContent?.title}
              </h1>
              <p className="paragraph1 py-3 fs-5 fw-bold">
                {headerContent?.subtitle}
              </p>
              <div className="">{renderDescription(headerContent?.description)}</div>
            </div>
          </div>
          <div className="col-lg-6 dNone">
            <img
              src={bgBannerImage}
              alt="o"
              className="bgImageBanner img-fluid"
            />
          </div>
        </div>
      </Container>
    </div>
  );
}
